import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import AdminLayout from "../../layout/AdminLayout";
import { useAuth } from "../../../context/AuthContext";
import * as model from "../../../models/ReportsModel";
import MonthlyReportsTable from "./MonthlyReportsTable";
import PageHeader from "../../common/PageHeader";
import config from "../../../config/config";
import { MyReactSelect, MyReactSelectMultiple } from "../../inputs/inputs";
import { use } from "react";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
//import { RequirementView } from "./RequirementView";

export default function MonthlyReports() {
    const module = {
        title: 'Monthly Reports',
        singularTitle: 'Monthly Report',
        key: 'monthly_reports',
        route: 'monthly-reports',
        primaryCol: ''
    };

    const { state } = useAuth();
    let user_data = state.user_data;
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [months, setMonths] = useState([]);
    const [isTrash, setIsTrash] = useState(false);

    const [listData, setListData] = useState([]);
    const [cacheTime, setCacheTime] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedMonth, setSelectedMonth] = useState(null);


    useEffect(() => {
        fetchMonths();
        // Initial fetch for the current month
        //console.log("Fetching months =>", months);
        //fetchData(limit, page);
    }, []);

    const fetchMonths = async () => {
        try {
            let apiParam = {
                user_token: user_data.user_token,
            };
            const response = await model.getMonthsList(apiParam);
            if (typeof response == typeof undefined) {
                navigate("/re-login");
                return;
            }
            //console.log("Months response =>", response.months);
            setMonths(response.months);
            // Set current month as default
            const currentMonth = new Date().toISOString().slice(0, 7); // e.g. "2025-08"
            const defaultMonth = response.months.find(m => m.value === currentMonth);
            setSelectedMonth(defaultMonth || response.months[0]);

            // Fetch data after setting the month
            fetchData(defaultMonth?.value || response.months[0]?.value);
        } catch (error) {
            console.error(error);
        }
    }

    const fetchData = async (month) => {
        setLoading(true);

        try {
            let apiParam = {
                user_token: user_data.user_token,
                month: month,
            };
            const response = await model.getMonthlyReport(apiParam);
            if (typeof response == typeof undefined) {
                navigate("/re-login");
                return;
            }

            setListData(response[module.key]);
            setTotalRows(response.pagination.total_rows);

            if (response.time) {
                setCacheTime(response.time);
            }

            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };
    
    const exportToExcel = async () => {
        if (!listData || listData.length === 0) {
            toast.warning("No data to export");
            return;
        }

        const monthLabel = selectedMonth?.label || "Unknown_Month";
        const fileName = `Monthly_Reports_${monthLabel.replace(/\s/g, "_")}.xlsx`;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Monthly Report");

        // Define headers and style
        const headers = [
            { header: "Name", key: "user_name" },
            { header: "DOJ", key: "user_start_date" },
            { header: "DM", key: "manager_name" },
            { header: "Total Positions", key: "total_positions" },
            { header: "Total Subs", key: "total_submissions" },
            { header: "Total Interviews", key: "total_interviews" },
            { header: "No Shows", key: "total_no_shows" },
        ];

        //worksheet.columns = headers;
        worksheet.columns = [
            { header: "Name", key: "user_name" },
            { header: "DOJ", key: "user_start_date" },
            { header: "DM", key: "manager_name" },
            { header: "Total Positions", key: "total_positions", style: { numFmt: "0" } },
            { header: "Total Subs", key: "total_submissions", style: { numFmt: "0" } },
            { header: "Total Interviews", key: "total_interviews", style: { numFmt: "0" } },
            { header: "No Shows", key: "total_no_shows", style: { numFmt: "0" } },
        ];

        // Add rows
        listData.forEach(row => {
            worksheet.addRow({
                user_name: row.user_name,
                user_start_date: row.user_start_date || "N/A",
                manager_name: row.manager_name || "N/A",
                total_positions: Number(row.total_positions) || 0,
                total_submissions: Number(row.total_submissions) || 0,
                total_interviews: Number(row.total_interviews) || 0,
                total_no_shows: Number(row.total_no_shows) || 0,
            });
        });

        // Style header
        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'D9E1F2' }, // Light blue
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = {
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        // Generate Excel file and save
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName);
    };

    return (
        <AdminLayout>
            <Helmet>
                <title>{module.title} - Digital CMS</title>
            </Helmet>
<style>
{`
    .rdt_TableHead {
        z-index: 2 !important; /* stay above body rows */
        position: sticky !important;
    }
    .cwjuei {
        position: sticky !important;
    }
`}
</style>
            <div className="main-content app-content">
                <div className="container-fluid">
                    <PageHeader module={module} isTrash={isTrash}  />
                    <div className="row">
                    {Array.isArray(months) && months.length > 0 && selectedMonth ? (
                        <div className="mb-3" style={{ maxWidth: 300 }}>
                            <select
                                className="form-select"
                                value={selectedMonth.value}
                                onChange={(e) => {
                                    const selected = months.find(m => m.value === e.target.value);
                                    setSelectedMonth(selected);
                                    fetchData(selected.value);
                                }}
                            >
                                {months.map((month) => (
                                    <option key={month.value} value={month.value}>
                                        {month.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    ) : (
                        <div className="mb-3" style={{ maxWidth: 300 }}>
                            <div className="form-control">Loading months...</div>
                        </div>
                    )}
                    {listData.length > 0 && (
                        <div className="col-xl-6 mt-1">
                            <button className="btn btn-primary ms-3" onClick={exportToExcel}>Download Excel</button>
                        </div>
                    )}
                        <div className="col-xl-12">
                            <div className="card custom-card">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <MonthlyReportsTable
                                            module={module}
                                            data={listData}
                                            loading={loading}
                                            totalRows={totalRows}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                
                </div>
            </div>
            <Helmet></Helmet>
        </AdminLayout>
    );
}
